<template>
  <div />
</template>

<script>
export default {
  name: 'GenerateInvoiceCoupon',
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  watch: {
    invoice: {
      handler(newVal) {
        if (newVal && newVal.headerDto && newVal.itemsDto && newVal.itemsDto.length > 0) {
          this.generateCouponTxt();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    generateCouponTxt() {
      console.log('Generating coupon TXT', this.invoice);
      const { headerDto, itemsDto } = this.invoice;
      // Tax rate mapping
      let mappedTaxRate = 5;
      let plu = itemsDto.barcode;
      if (plu == null) {
        plu = itemsDto.articleNumber;
      }
      if (headerDto.taxRate === 0 || headerDto.taxRate === 0.00 || headerDto.taxRate === '0.00') mappedTaxRate = 3;
      else if (headerDto.taxRate === 8 || headerDto.taxRate === 8.00 || headerDto.taxRate === '8.00') mappedTaxRate = 4;
      else if (headerDto.taxRate === 18 || headerDto.taxRate === 18.00 || headerDto.taxRate === '18.00') mappedTaxRate = 5;

      const sLines = itemsDto.map((item, idx) => {
        const start = ['S', idx + 1, '______', '_', '__'].join(',');
        plu = item.barcode || item.articleNumber || '';
        const end = [
          item.articleNumber || '',
          item.priceWithDiscount.toFixed(2) || '0.00',
          item.quantity || 0,
          1, 1,
          mappedTaxRate,
          0,
          plu, 0, 0.00,
        ].join(';');
        return `${start};${end}`;
      });

      const totalDiscount = `-${headerDto.discount}`;
      const cLineStart = ['C', 1, '______', '_', '__'].join(',');
      const cLineEnd = [0, 0, totalDiscount].join(';');
      const cLine = `${cLineStart};${cLineEnd}`;

      const tLineStart = ['T', 1, '______', '_', '__'].join(',');
      const tLineEnd = ['', ''].join(';');
      const tLine = `${tLineStart};${tLineEnd}`;

      const content = [...sLines, cLine, tLine].join('\n');

      // Download as inp
      const blob = new Blob([content], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `coupon_${headerDto.orderNumber || Date.now()}.inp`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
  },
};
</script>
